export default function debounce(callback, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, args), wait);
  };
}



// WEBPACK FOOTER //
// ./scripts/util/debounce.js